import moment from "moment";
import "./index.css";

export const DateColumnsManagement = ({ dateColumns }) => {
  return (
    <thead className="sticky-date-column">
      <tr>
        <th className="sticky-room-column">Room</th>
        {dateColumns.map((date) => {
          const day = moment(date, "DD MMM").day();
          const isSaturday = day === 6;
          const isSunday = day === 0;
          return (
            <th
              key={date}
              className={`${
                isSaturday || isSunday ? " weekend-highlight" : ""
              }`}
            >
              {date}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};
